// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import * as antlr4 from 'antlr4';

 /* eslint-disable */ 

const serializedATN = [4,0,29,247,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,
4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,
12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,
2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,26,2,
27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,1,0,1,0,1,1,1,
1,1,2,1,2,1,3,1,3,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,
5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,
7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,
8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,10,1,10,1,10,1,10,1,11,1,11,1,11,1,11,
1,11,1,11,1,12,1,12,1,12,1,12,1,12,1,12,1,13,1,13,1,13,1,13,1,13,1,13,1,
14,4,14,157,8,14,11,14,12,14,158,1,15,4,15,162,8,15,11,15,12,15,163,1,15,
1,15,4,15,168,8,15,11,15,12,15,169,1,16,1,16,5,16,174,8,16,10,16,12,16,177,
9,16,1,16,1,16,1,17,1,17,5,17,183,8,17,10,17,12,17,186,9,17,1,17,1,17,1,
17,1,18,1,18,5,18,193,8,18,10,18,12,18,196,9,18,1,18,1,18,1,19,1,19,1,19,
1,19,4,19,204,8,19,11,19,12,19,205,1,20,4,20,209,8,20,11,20,12,20,210,1,
20,1,20,1,21,3,21,216,8,21,1,21,1,21,4,21,220,8,21,11,21,12,21,221,1,21,
1,21,1,22,1,22,1,23,1,23,1,24,1,24,1,25,1,25,1,26,1,26,1,27,1,27,1,28,1,
28,1,29,1,29,1,30,1,30,1,31,1,31,1,32,1,32,3,175,184,194,0,33,1,0,3,0,5,
0,7,0,9,1,11,2,13,3,15,4,17,5,19,6,21,7,23,8,25,9,27,10,29,11,31,12,33,13,
35,14,37,15,39,16,41,17,43,18,45,19,47,20,49,21,51,22,53,23,55,24,57,25,
59,26,61,27,63,28,65,29,1,0,5,1,0,97,122,1,0,65,90,1,0,48,57,9,0,9,10,13,
13,32,32,34,34,40,57,61,61,65,93,97,123,125,125,2,0,9,9,32,32,256,0,9,1,
0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,
21,1,0,0,0,0,23,1,0,0,0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,
0,0,0,33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,0,43,
1,0,0,0,0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,0,53,1,0,0,0,
0,55,1,0,0,0,0,57,1,0,0,0,0,59,1,0,0,0,0,61,1,0,0,0,0,63,1,0,0,0,0,65,1,
0,0,0,1,67,1,0,0,0,3,69,1,0,0,0,5,71,1,0,0,0,7,73,1,0,0,0,9,75,1,0,0,0,11,
80,1,0,0,0,13,93,1,0,0,0,15,104,1,0,0,0,17,117,1,0,0,0,19,125,1,0,0,0,21,
133,1,0,0,0,23,137,1,0,0,0,25,143,1,0,0,0,27,149,1,0,0,0,29,156,1,0,0,0,
31,161,1,0,0,0,33,171,1,0,0,0,35,180,1,0,0,0,37,190,1,0,0,0,39,203,1,0,0,
0,41,208,1,0,0,0,43,219,1,0,0,0,45,225,1,0,0,0,47,227,1,0,0,0,49,229,1,0,
0,0,51,231,1,0,0,0,53,233,1,0,0,0,55,235,1,0,0,0,57,237,1,0,0,0,59,239,1,
0,0,0,61,241,1,0,0,0,63,243,1,0,0,0,65,245,1,0,0,0,67,68,7,0,0,0,68,2,1,
0,0,0,69,70,7,1,0,0,70,4,1,0,0,0,71,72,7,2,0,0,72,6,1,0,0,0,73,74,8,3,0,
0,74,8,1,0,0,0,75,76,5,110,0,0,76,77,5,117,0,0,77,78,5,108,0,0,78,79,5,108,
0,0,79,10,1,0,0,0,80,81,5,71,0,0,81,82,5,101,0,0,82,83,5,116,0,0,83,84,5,
83,0,0,84,85,5,116,0,0,85,86,5,97,0,0,86,87,5,114,0,0,87,88,5,116,0,0,88,
89,5,68,0,0,89,90,5,97,0,0,90,91,5,116,0,0,91,92,5,101,0,0,92,12,1,0,0,0,
93,94,5,71,0,0,94,95,5,101,0,0,95,96,5,116,0,0,96,97,5,69,0,0,97,98,5,110,
0,0,98,99,5,100,0,0,99,100,5,68,0,0,100,101,5,97,0,0,101,102,5,116,0,0,102,
103,5,101,0,0,103,14,1,0,0,0,104,105,5,71,0,0,105,106,5,101,0,0,106,107,
5,116,0,0,107,108,5,68,0,0,108,109,5,97,0,0,109,110,5,116,0,0,110,111,5,
101,0,0,111,112,5,82,0,0,112,113,5,97,0,0,113,114,5,110,0,0,114,115,5,103,
0,0,115,116,5,101,0,0,116,16,1,0,0,0,117,118,5,65,0,0,118,119,5,100,0,0,
119,120,5,100,0,0,120,121,5,68,0,0,121,122,5,97,0,0,122,123,5,121,0,0,123,
124,5,115,0,0,124,18,1,0,0,0,125,126,5,82,0,0,126,127,5,101,0,0,127,128,
5,112,0,0,128,129,5,108,0,0,129,130,5,97,0,0,130,131,5,99,0,0,131,132,5,
101,0,0,132,20,1,0,0,0,133,134,5,71,0,0,134,135,5,101,0,0,135,136,5,116,
0,0,136,22,1,0,0,0,137,138,5,80,0,0,138,139,5,97,0,0,139,140,5,114,0,0,140,
141,5,115,0,0,141,142,5,101,0,0,142,24,1,0,0,0,143,144,5,85,0,0,144,145,
5,112,0,0,145,146,5,112,0,0,146,147,5,101,0,0,147,148,5,114,0,0,148,26,1,
0,0,0,149,150,5,76,0,0,150,151,5,111,0,0,151,152,5,119,0,0,152,153,5,101,
0,0,153,154,5,114,0,0,154,28,1,0,0,0,155,157,3,5,2,0,156,155,1,0,0,0,157,
158,1,0,0,0,158,156,1,0,0,0,158,159,1,0,0,0,159,30,1,0,0,0,160,162,3,5,2,
0,161,160,1,0,0,0,162,163,1,0,0,0,163,161,1,0,0,0,163,164,1,0,0,0,164,165,
1,0,0,0,165,167,5,46,0,0,166,168,3,5,2,0,167,166,1,0,0,0,168,169,1,0,0,0,
169,167,1,0,0,0,169,170,1,0,0,0,170,32,1,0,0,0,171,175,5,34,0,0,172,174,
9,0,0,0,173,172,1,0,0,0,174,177,1,0,0,0,175,176,1,0,0,0,175,173,1,0,0,0,
176,178,1,0,0,0,177,175,1,0,0,0,178,179,5,34,0,0,179,34,1,0,0,0,180,184,
5,123,0,0,181,183,9,0,0,0,182,181,1,0,0,0,183,186,1,0,0,0,184,185,1,0,0,
0,184,182,1,0,0,0,185,187,1,0,0,0,186,184,1,0,0,0,187,188,5,125,0,0,188,
189,6,17,0,0,189,36,1,0,0,0,190,194,5,91,0,0,191,193,9,0,0,0,192,191,1,0,
0,0,193,196,1,0,0,0,194,195,1,0,0,0,194,192,1,0,0,0,195,197,1,0,0,0,196,
194,1,0,0,0,197,198,5,93,0,0,198,38,1,0,0,0,199,204,3,1,0,0,200,204,3,3,
1,0,201,204,3,5,2,0,202,204,3,7,3,0,203,199,1,0,0,0,203,200,1,0,0,0,203,
201,1,0,0,0,203,202,1,0,0,0,204,205,1,0,0,0,205,203,1,0,0,0,205,206,1,0,
0,0,206,40,1,0,0,0,207,209,7,4,0,0,208,207,1,0,0,0,209,210,1,0,0,0,210,208,
1,0,0,0,210,211,1,0,0,0,211,212,1,0,0,0,212,213,6,20,1,0,213,42,1,0,0,0,
214,216,5,13,0,0,215,214,1,0,0,0,215,216,1,0,0,0,216,217,1,0,0,0,217,220,
5,10,0,0,218,220,5,13,0,0,219,215,1,0,0,0,219,218,1,0,0,0,220,221,1,0,0,
0,221,219,1,0,0,0,221,222,1,0,0,0,222,223,1,0,0,0,223,224,6,21,1,0,224,44,
1,0,0,0,225,226,5,43,0,0,226,46,1,0,0,0,227,228,5,45,0,0,228,48,1,0,0,0,
229,230,5,42,0,0,230,50,1,0,0,0,231,232,5,47,0,0,232,52,1,0,0,0,233,234,
5,40,0,0,234,54,1,0,0,0,235,236,5,41,0,0,236,56,1,0,0,0,237,238,5,44,0,0,
238,58,1,0,0,0,239,240,5,61,0,0,240,60,1,0,0,0,241,242,5,91,0,0,242,62,1,
0,0,0,243,244,5,93,0,0,244,64,1,0,0,0,245,246,5,46,0,0,246,66,1,0,0,0,13,
0,158,163,169,175,184,194,203,205,210,215,219,221,2,1,17,0,6,0,0];


const atn = new antlr4.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.DFA(ds, index) );

export default class DataLexer extends antlr4.Lexer {

    static grammarFileName = "DataLexer.g4";
    static channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	static modeNames = [ "DEFAULT_MODE" ];
	static literalNames = [ null, "'null'", "'GetStartDate'", "'GetEndDate'", 
                         "'GetDateRange'", "'AddDays'", "'Replace'", "'Get'", 
                         "'Parse'", "'Upper'", "'Lower'", null, null, null, 
                         null, null, null, null, null, "'+'", "'-'", "'*'", 
                         "'/'", "'('", "')'", "','", "'='", "'['", "']'", 
                         "'.'" ];
	static symbolicNames = [ null, "NULL", "STARTDATE", "ENDDATE", "DATERANGE", 
                          "ADDDAYS", "REPLACE", "GET", "PARSE", "UPPER", 
                          "LOWER", "INTEGER", "DECIMAL", "TEXT", "BRACES", 
                          "LOOKUP", "WORD", "WHITESPACE", "NEWLINE", "PLUS", 
                          "MINUS", "ASTERISK", "DIVISION", "LPAREN", "RPAREN", 
                          "COMMA", "EQUALS", "LBRACKET", "RBRACKET", "PERIOD" ];
	static ruleNames = [ "LOWERCASE", "UPPERCASE", "DIGIT", "OTHER", "NULL", 
                      "STARTDATE", "ENDDATE", "DATERANGE", "ADDDAYS", "REPLACE", 
                      "GET", "PARSE", "UPPER", "LOWER", "INTEGER", "DECIMAL", 
                      "TEXT", "BRACES", "LOOKUP", "WORD", "WHITESPACE", 
                      "NEWLINE", "PLUS", "MINUS", "ASTERISK", "DIVISION", 
                      "LPAREN", "RPAREN", "COMMA", "EQUALS", "LBRACKET", 
                      "RBRACKET", "PERIOD" ];

    constructor(input) {
        super(input)
        this._interp = new antlr4.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    }

    get atn() {
        return atn;
    }
}

DataLexer.EOF = antlr4.Token.EOF;
DataLexer.NULL = 1;
DataLexer.STARTDATE = 2;
DataLexer.ENDDATE = 3;
DataLexer.DATERANGE = 4;
DataLexer.ADDDAYS = 5;
DataLexer.REPLACE = 6;
DataLexer.GET = 7;
DataLexer.PARSE = 8;
DataLexer.UPPER = 9;
DataLexer.LOWER = 10;
DataLexer.INTEGER = 11;
DataLexer.DECIMAL = 12;
DataLexer.TEXT = 13;
DataLexer.BRACES = 14;
DataLexer.LOOKUP = 15;
DataLexer.WORD = 16;
DataLexer.WHITESPACE = 17;
DataLexer.NEWLINE = 18;
DataLexer.PLUS = 19;
DataLexer.MINUS = 20;
DataLexer.ASTERISK = 21;
DataLexer.DIVISION = 22;
DataLexer.LPAREN = 23;
DataLexer.RPAREN = 24;
DataLexer.COMMA = 25;
DataLexer.EQUALS = 26;
DataLexer.LBRACKET = 27;
DataLexer.RBRACKET = 28;
DataLexer.PERIOD = 29;

DataLexer.prototype.action = function(localctx, ruleIndex, actionIndex) {
	switch (ruleIndex) {
	case 17:
		this.BRACES_action(localctx, actionIndex);
		break;
	default:
		throw "No registered action for:" + ruleIndex;
	}
};


DataLexer.prototype.BRACES_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 0:

		                        var str = this.text;
		                        str = str.substring(1, str.length - 1);
		                        this.text = str;
		                    
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};



